export default (theme) => ({
  avatarColor: {
    backgroundColor: theme.color.black,
  },
  listItem: {
    cursor: 'pointer',
    alignItems: 'flex-start',
  },
  avatarRoot: {
    marginTop: theme.spacing(1),
    position: 'relative',
    zIndex: 1,
  },
  name: {
    '& .MuiListItemText-primary': {
      position: 'relative',
      zIndex: 1,
    },
  },
  title: {
    fontSize: '16px',
    textTransform: 'uppercase',
    fontWeight: 'normal',
    color: theme.color.grey_55,
  },
});
